'use strict';/* global define */define('modules/core/modules/translate/directives/language-switch/controller',['require','exports','module','angular'],function(require,exports,module){'use strict';
     controller.$inject = ["Languages", "CurrentLanguage"];var ng=require('angular');// @ngInject
function controller(Languages,CurrentLanguage){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.language=CurrentLanguage.get();ctrl.languages=Languages.get();ctrl.languages.$promise.then(function(){_evalLanguages();});ctrl.setLanguage=setLanguage;// ---
/**
     * Set current used language
     *
     * @param {String} language - locale string
     *
     * @tested
     */function setLanguage(language){CurrentLanguage.set(language);ctrl.language=language;_evalLanguages();}/**
     * Evaluate retrieved language and
     * evaluate if they are active and perform
     * some manipulation to save function calls
     * inside of template
     *
     * @private
     * @tested
     */function _evalLanguages(){ctrl.languages.forEach(function(language){language.active=language.locale===ctrl.language;language.upperLocale=language.locale.toUpperCase();});}}module.exports=controller;});
